import { inject } from "@angular/core";
import { CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { RouteAccessService } from "@core/services/route-access.service";

export const AuthGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot
) => {
  return inject(RouteAccessService).canActivateRoute(state);
};
